export const GUEST_EMAIL = import.meta.env.VITE_GUEST_EMAIL ?? "";
export const GUEST_PASSWORD = import.meta.env.VITE_GUEST_PASSWORD ?? "";
